"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  primary: {
    main: "#216C2A",
    light: "#278032"
  }
};
exports.default = _default;